import React, { Component } from 'react';

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentSend from 'material-ui/svg-icons/content/send';

import {List, ListItem} from 'material-ui/List';
import Checkbox from 'material-ui/Checkbox';

import clientsStore from '../../stores/clientsStore';

import _ from 'lodash';

const Target = ({item}) => (
    <div>
        {item.clientName}
        <br />
        <List>
            {
                item.storedCommands.map((item, index) => (
                    <ListItem key={index}
                        leftCheckbox={<Checkbox defaultChecked={true} />}
                        primaryText={`${item.target} (${item.arguments})` }
                        secondaryText={item.workingDirectory}
                        data-storedcommandid={item.StoredCommandID}
                    />
                ))
            }
                
        </List>
    </div>
)

const TargetsList = ({targets}) => (
    <div id="CommandsList">
        {
            targets.map((item, index) => <Target key={index} item={item} />)
        }
    </div>
)

class SendTask extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            clients: [],
            targets: []
        }
    }

    componentWillMount() {
        
    }

    componentWillReceiveProps(nextProps) {
        this.setState({clients: nextProps.clients});
    }
    
    handleOpen() {
        if(!this.props.trueTarget) {
            let trueRows = [];
            let trueTargets = [];
            document.getElementById("listClients").querySelectorAll("label").forEach((item, index) => {
                if(item.querySelector("input").checked) {
                    trueRows.push(this.state.clients[index].clientID);
                    trueTargets.push(this.state.clients[index]);
                }
            });
            console.log(trueRows);
            if(trueRows.length > 0) {
                console.log(trueTargets);
                this.setState({open: true, targets: trueTargets});
            }
        } else {
            this.setState({open: true, targets: this.props.trueTarget});
        }
        
    };

    handleClose() {
        this.setState({open: false});
    };

    _send() {
        this.handleClose();
        console.log("TRUE TARGET:: " + JSON.stringify(this.state.targets[0].storedCommands));
        console.log("STATE CLIENTS: " + JSON.stringify(this.state.clients));

        let taskToSend = [];
        document.getElementById("CommandsList").querySelectorAll("label").forEach((item, index) => {
            // OBTENER EL ID DE LOS STOREDCOMMANDS
            // COMPARARLOS CON LA LISTA DE COMANDOS DE LOS CLIENTES TOTALES, UN LOOP
            // OBTENER INFORMACION DE LOS STOREDCOMMANDS QUE ESTAN CHEQUADOS PARA ENVIARLOS A TRAVES DE UNA VARIABLE Y LISTO :D

            // ELIMINAR DE STOREDCOMMANDS UNA VEZ ESTEN INGRESADOS EN COMMANDS???
            // DE SER ASI UNA VEZ ELIMINADOS, NO OLVIDAR ACTUALIZAR EL CACHE DE LA PAGINA (SE REALIZA AUTOMATICAMENTE??)

            console.log("TEXTO?: " + JSON.stringify(this.state.targets[0].storedCommands));
            var dataToSend;
            if(item.querySelector("input").checked) {
                dataToSend = _.find(this.state.targets[0].storedCommands, (command) => {return command.StoredCommandID === item.dataset.storedcommandid} );
                console.log("MATCHING?: " + JSON.stringify(_.find(this.state.targets[0].storedCommands, (command) => {return command.StoredCommandID === item.dataset.storedcommandid} )));
                console.log("ITEM DATASET: " + JSON.stringify(item.dataset));
                taskToSend.push({
                    command: {
                        clientID        : dataToSend.clientID,
                        commandTarget   : dataToSend.target,
                        commandArguments: dataToSend.arguments,
                        workingDirectory: dataToSend.workingDirectory
                    }
                });
                console.log("????: " + JSON.stringify(dataToSend.clientID));
            }
        });
        // TODO:SEND TO THE SERVER
        // console.log("TASK TO SEND TO METHOD: " + JSON.stringify(taskToSend));
        _.forEach(taskToSend, function(item) {
            clientsStore.createCommand(item);
            // MENSAJE: SE ESTAN AGREGANDO LOS COMANDOS
            /* SI ONSUCCESS ENTONCES ELIMINAR POR RESPUESTA EN ROWS(commandID) */
            //clientsStore.orderCommands();
        });
        // console.log("ACABO DE ENVIAR");
        
    }

    render() {
        //console.log("THIS PROPS TRUETARGET: " + JSON.stringify(this.props.trueTarget));
        const actions = [
            <FlatButton
                label="Cancelar"
                primary={true}
                onTouchTap={ () => { this.handleClose() } }
            />,
            <FlatButton
                label="Enviar"
                primary={true}
                keyboardFocused={true}
                onTouchTap={ () => { this._send() } }
            />,
        ];
        return (
            <div>
                <FloatingActionButton 
                    style={{position: "fixed", right: "32px", bottom: "32px"}} 
                    label="Enviar tarea" 
                    onTouchTap={() => { this.handleOpen() } } >
                    <ContentSend />
                </FloatingActionButton>
                <Dialog
                    title="Enviar tarea"
                    actions={actions}
                    modal={false}
                    open={this.state.open}
                    onRequestClose={() => { this.handleClose() }}
                    autoScrollBodyContent={true}
                >
                <TargetsList targets={this.state.targets} />
                </Dialog>
            </div>
        );
    }
}

export default SendTask;


// WEBPACK FOOTER //
// ./src/components/MainComponents/SendTask.js